import { api } from "@/utils/axios";

export const deviceService = {
  deviceList(body) {
    return api.post(
      "?c=Port&m=Web_Port&module=Set_device&opt=device_list",
      body
    );
  },
};
